// eslint-disable-next-line import/order
import type { Action } from 'react-sweet-state';
// eslint-disable-next-line @atlassian/tangerine/import/no-dangling-index
import type { RemoteActionsStoreState } from '..';
// eslint-disable-next-line import/order
import type { ProductData, RemoteActionsResponse, Product } from '../../../common/types';
import { clearActionId } from './clear-action-id';
import { initStore } from './init-store';
import { processRemoteActions } from './process-remote-actions';
import { saveActionPerformedAttempt } from './save-action-performed-attempt';

export const actions: {
	clearActionId: (actionId: string) => Action<
		RemoteActionsStoreState,
		{
			product: Product;
		}
	>;
	initStore: () => Action<
		RemoteActionsStoreState,
		{
			product: Product;
		}
	>;
	processRemoteActions: (
		productData: ProductData,
		remoteActionsResponse: RemoteActionsResponse,
	) => Action<RemoteActionsStoreState>;
	saveActionPerformedAttempt: (actionId: string) => Action<RemoteActionsStoreState>;
} = {
	processRemoteActions,
	saveActionPerformedAttempt,
	initStore,
	clearActionId,
};
export type RemoteActionsActions = typeof actions;
